import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "send-form modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "showDocusignListModel",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLongTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLongTitle"
  }, " Send digitized form "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "form-wrap pt-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("strong", null, "Digitized Pdf List")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn secondary-btn",
    "data-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocusignDocumentListTable = _resolveComponent("DocusignDocumentListTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_DocusignDocumentListTable, {
                docs: _ctx.state.data.clientDocuments,
                heading: _ctx.state.data.hearder,
                memberList: _ctx.channelMemberList,
                from: _ctx.state.data.from,
                channelUuid: _ctx.channelId
              }, null, 8, ["docs", "heading", "memberList", "from", "channelUuid"])
            ])
          ]),
          _hoisted_9
        ])
      ])
    ])
  ]))
}